import { memo, useState } from "react";
import imageOnTheWay from '../../../../public/assets/images/imageOnTheWay.webp';
import noPhoto from '../../../../public/assets/images/no-photo-3x.png';
 
const ImageSingle = ({imageUrl, style, onClick, onMouseOver, onMouseOut, href, isPDP}) => {
  const [hasError, setHasError] = useState(false);
  return (
    <>
    {
      isPDP?
      <>
       <img
        className="img-whp cursor-pointer "
        defaultValue={isPDP? noPhoto : imageOnTheWay}
        style={style}
        src={hasError ? isPDP? noPhoto : imageOnTheWay : imageUrl?.indexOf('https') > -1 ? imageUrl : 'https:' + imageUrl}
        onError={() => setHasError(true)}
        alt="Default image"
        onClick={(e) => onClick && onClick(e)}
        onMouseOver={onMouseOver}
        onMouseOut={onMouseOut}
      />
      </>:
    <a href={href} onClick={(e) => e.preventDefault()}>
      <img
        className="img-whp cursor-pointer"
        defaultValue={isPDP? noPhoto : imageOnTheWay}
        style={style}
        src={hasError ? isPDP? noPhoto : imageOnTheWay : imageUrl?.indexOf('https') > -1 ? imageUrl : 'https:' + imageUrl}
        onError={() => setHasError(true)}
        alt="Default image"
        onClick={(e) => onClick && onClick(e)}
        onMouseOver={onMouseOver}
        onMouseOut={onMouseOut}
      />
    </a>
    }
    </>
  );
};
 
export default memo(ImageSingle);